import { CompanyImportController } from "../../../controllers";
import { DataImportComponentBase } from "./DataImportComponentBase";

/**
 * User interface for worker mass loading.
 * @example
 * ```html
 * <salaxy-company-import></salaxy-company-import>
 * ```
 */
export class CompanyImport extends DataImportComponentBase {

    /** Uses the CompanyImportController */
    public controller = CompanyImportController;

}